// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-family-page {
    min-height: 100vh;
    background: #0d0d10;
}

.ai-family-hero {
    position: relative;
    min-height: 100vh;
    min-height: 100svh;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background:
        linear-gradient(135deg, rgba(10, 10, 12, 0.97), rgba(33, 12, 15, 0.94)),
        #0d0d10;
    color: #ffffff;
}

.ai-family-hero-bg {
    position: absolute;
    inset: 0;
}

.ai-family-grid {
    position: absolute;
    inset: -24%;
    background-image:
        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),
        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);
    background-size: 44px 44px;
    transform: perspective(720px) rotateX(64deg);
    animation: aiFamilyGridMove 24s linear infinite;
}

.ai-family-glow {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(circle at 50% 22%, rgba(217, 0, 27, 0.24), transparent 20%),
        radial-gradient(circle at 18% 78%, rgba(217, 0, 27, 0.14), transparent 28%),
        radial-gradient(circle at 82% 68%, rgba(255, 255, 255, 0.08), transparent 24%);
}

.ai-family-noise {
    position: absolute;
    inset: 0;
    background:
        linear-gradient(rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)),
        repeating-linear-gradient(
            90deg,
            transparent 0,
            transparent 14px,
            rgba(255, 255, 255, 0.015) 14px,
            rgba(255, 255, 255, 0.015) 15px
        );
    opacity: 0.45;
}

.ai-family-hero-content {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    min-height: 100svh;
    padding-top: 132px;
    padding-bottom: 84px;
}

.ai-family-hero-copy {
    width: min(100%, 980px);
    display: grid;
    justify-items: center;
    text-align: center;
    align-content: center;
}

.ai-family-visual-shell {
    position: relative;
    margin-bottom: 26px;
    width: min(42vw, 300px);
    min-width: 220px;
}

.ai-family-visual-ring {
    position: absolute;
    inset: -18px;
    border-radius: 32px;
    background:
        linear-gradient(135deg, rgba(217, 0, 27, 0.32), rgba(255, 255, 255, 0.08)),
        rgba(255, 255, 255, 0.04);
    filter: blur(2px);
    opacity: 0.82;
}

.ai-family-visual-card {
    position: relative;
    border-radius: 28px;
    overflow: hidden;
    background:
        radial-gradient(circle at 50% 16%, rgba(255, 255, 255, 0.16), transparent 34%),
        linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));
    border: 1px solid rgba(255, 255, 255, 0.14);
    backdrop-filter: blur(14px);
    box-shadow:
        0 24px 60px rgba(0, 0, 0, 0.28),
        inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.ai-family-visual-image {
    width: 100%;
    display: block;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    object-position: center;
}

.ai-family-kicker {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 14px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
    font-size: 0.78rem;
    font-weight: 800;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: #ff8f99;
}

.ai-family-hero-title {
    max-width: none;
    margin: 20px 0 14px;
    font-size: clamp(2.4rem, 4.2vw, 4.8rem);
    line-height: 1.06;
    letter-spacing: -0.03em;
    white-space: nowrap;
    text-wrap: balance;
}

.ai-family-hero-subtitle {
    max-width: 680px;
    margin: 0;
    color: rgba(255, 255, 255, 0.82);
    font-size: clamp(1rem, 1.15vw, 1.18rem);
    line-height: 1.86;
}

.ai-family-hero-actions {
    margin-top: 30px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 14px;
}

.ai-family-hero-button {
    min-width: 172px;
    padding: 15px 28px;
    border-radius: 999px;
    font-weight: 700;
    transition:
        transform 0.22s ease,
        box-shadow 0.22s ease,
        background 0.22s ease,
        border-color 0.22s ease;
}

.ai-family-hero-button.is-primary {
    background: var(--accent-red);
    color: #ffffff;
    box-shadow: 0 14px 30px rgba(217, 0, 27, 0.24);
}

.ai-family-hero-button.is-primary:hover {
    background: var(--accent-red-hover);
    transform: translateY(-2px);
    box-shadow: 0 18px 34px rgba(217, 0, 27, 0.28);
}

.ai-family-hero-button.is-secondary {
    background: rgba(255, 255, 255, 0.06);
    color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.16);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.ai-family-hero-button.is-secondary:hover {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.24);
    transform: translateY(-2px);
}

.ai-family-hero-button.is-disabled {
    background: rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.78);
    border: 1px solid rgba(255, 255, 255, 0.14);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
    cursor: not-allowed;
    pointer-events: none;
}

@keyframes aiFamilyGridMove {
    from {
        transform: perspective(720px) rotateX(64deg) translateY(0);
    }

    to {
        transform: perspective(720px) rotateX(64deg) translateY(44px);
    }
}

@media (max-width: 768px) {
    .ai-family-hero-content {
        padding-top: 118px;
        padding-bottom: 64px;
        min-height: 100svh;
    }

    .ai-family-visual-shell {
        width: min(68vw, 280px);
        min-width: 0;
        margin-bottom: 22px;
    }

    .ai-family-visual-ring {
        inset: -12px;
        border-radius: 24px;
    }

    .ai-family-visual-card {
        border-radius: 22px;
    }

    .ai-family-hero-title {
        margin-top: 18px;
        max-width: 100%;
        font-size: clamp(1.95rem, 8.2vw, 3rem);
        line-height: 1.14;
        white-space: normal;
    }

    .ai-family-hero-actions {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr;
        gap: 12px;
    }

    .ai-family-hero-button {
        width: 100%;
        min-width: 0;
        padding: 14px 22px;
    }

    .ai-family-hero-subtitle {
        max-width: 100%;
        font-size: 0.98rem;
        line-height: 1.78;
    }

    .ai-family-kicker {
        font-size: 0.72rem;
        letter-spacing: 0.14em;
    }
}

@media (prefers-reduced-motion: reduce) {
    .ai-family-grid,
    .ai-family-hero-button {
        animation: none;
        transition: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/ai-family.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB;;eAEW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX;;+EAE2E;IAC3E,0BAA0B;IAC1B,4CAA4C;IAC5C,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;;;sFAGkF;AACtF;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR;;;;;;;;SAQK;IACL,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB;;iCAE6B;IAC7B,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB;;qFAEiF;IACjF,2CAA2C;IAC3C,2BAA2B;IAC3B;;+CAE2C;AAC/C;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,uCAAuC;IACvC,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,gCAAgC;IAChC,uCAAuC;IACvC,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB;;;;+BAI2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,2CAA2C;IAC3C,mDAAmD;AACvD;;AAEA;IACI,oCAAoC;IACpC,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,2CAA2C;IAC3C,mDAAmD;IACnD,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI;QACI,0DAA0D;IAC9D;;IAEA;QACI,6DAA6D;IACjE;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,sCAAsC;QACtC,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;AACJ;;AAEA;IACI;;QAEI,eAAe;QACf,gBAAgB;IACpB;AACJ","sourcesContent":[".ai-family-page {\r\n    min-height: 100vh;\r\n    background: #0d0d10;\r\n}\r\n\r\n.ai-family-hero {\r\n    position: relative;\r\n    min-height: 100vh;\r\n    min-height: 100svh;\r\n    overflow: hidden;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background:\r\n        linear-gradient(135deg, rgba(10, 10, 12, 0.97), rgba(33, 12, 15, 0.94)),\r\n        #0d0d10;\r\n    color: #ffffff;\r\n}\r\n\r\n.ai-family-hero-bg {\r\n    position: absolute;\r\n    inset: 0;\r\n}\r\n\r\n.ai-family-grid {\r\n    position: absolute;\r\n    inset: -24%;\r\n    background-image:\r\n        linear-gradient(to right, rgba(217, 0, 27, 0.12) 1px, transparent 1px),\r\n        linear-gradient(to bottom, rgba(217, 0, 27, 0.08) 1px, transparent 1px);\r\n    background-size: 44px 44px;\r\n    transform: perspective(720px) rotateX(64deg);\r\n    animation: aiFamilyGridMove 24s linear infinite;\r\n}\r\n\r\n.ai-family-glow {\r\n    position: absolute;\r\n    inset: 0;\r\n    background:\r\n        radial-gradient(circle at 50% 22%, rgba(217, 0, 27, 0.24), transparent 20%),\r\n        radial-gradient(circle at 18% 78%, rgba(217, 0, 27, 0.14), transparent 28%),\r\n        radial-gradient(circle at 82% 68%, rgba(255, 255, 255, 0.08), transparent 24%);\r\n}\r\n\r\n.ai-family-noise {\r\n    position: absolute;\r\n    inset: 0;\r\n    background:\r\n        linear-gradient(rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)),\r\n        repeating-linear-gradient(\r\n            90deg,\r\n            transparent 0,\r\n            transparent 14px,\r\n            rgba(255, 255, 255, 0.015) 14px,\r\n            rgba(255, 255, 255, 0.015) 15px\r\n        );\r\n    opacity: 0.45;\r\n}\r\n\r\n.ai-family-hero-content {\r\n    position: relative;\r\n    z-index: 1;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    min-height: 100vh;\r\n    min-height: 100svh;\r\n    padding-top: 132px;\r\n    padding-bottom: 84px;\r\n}\r\n\r\n.ai-family-hero-copy {\r\n    width: min(100%, 980px);\r\n    display: grid;\r\n    justify-items: center;\r\n    text-align: center;\r\n    align-content: center;\r\n}\r\n\r\n.ai-family-visual-shell {\r\n    position: relative;\r\n    margin-bottom: 26px;\r\n    width: min(42vw, 300px);\r\n    min-width: 220px;\r\n}\r\n\r\n.ai-family-visual-ring {\r\n    position: absolute;\r\n    inset: -18px;\r\n    border-radius: 32px;\r\n    background:\r\n        linear-gradient(135deg, rgba(217, 0, 27, 0.32), rgba(255, 255, 255, 0.08)),\r\n        rgba(255, 255, 255, 0.04);\r\n    filter: blur(2px);\r\n    opacity: 0.82;\r\n}\r\n\r\n.ai-family-visual-card {\r\n    position: relative;\r\n    border-radius: 28px;\r\n    overflow: hidden;\r\n    background:\r\n        radial-gradient(circle at 50% 16%, rgba(255, 255, 255, 0.16), transparent 34%),\r\n        linear-gradient(180deg, rgba(255, 255, 255, 0.08), rgba(255, 255, 255, 0.02));\r\n    border: 1px solid rgba(255, 255, 255, 0.14);\r\n    backdrop-filter: blur(14px);\r\n    box-shadow:\r\n        0 24px 60px rgba(0, 0, 0, 0.28),\r\n        inset 0 1px 0 rgba(255, 255, 255, 0.12);\r\n}\r\n\r\n.ai-family-visual-image {\r\n    width: 100%;\r\n    display: block;\r\n    aspect-ratio: 1 / 1;\r\n    object-fit: cover;\r\n    object-position: center;\r\n}\r\n\r\n.ai-family-kicker {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 8px 14px;\r\n    border-radius: 999px;\r\n    background: rgba(255, 255, 255, 0.08);\r\n    border: 1px solid rgba(255, 255, 255, 0.12);\r\n    font-size: 0.78rem;\r\n    font-weight: 800;\r\n    letter-spacing: 0.16em;\r\n    text-transform: uppercase;\r\n    color: #ff8f99;\r\n}\r\n\r\n.ai-family-hero-title {\r\n    max-width: none;\r\n    margin: 20px 0 14px;\r\n    font-size: clamp(2.4rem, 4.2vw, 4.8rem);\r\n    line-height: 1.06;\r\n    letter-spacing: -0.03em;\r\n    white-space: nowrap;\r\n    text-wrap: balance;\r\n}\r\n\r\n.ai-family-hero-subtitle {\r\n    max-width: 680px;\r\n    margin: 0;\r\n    color: rgba(255, 255, 255, 0.82);\r\n    font-size: clamp(1rem, 1.15vw, 1.18rem);\r\n    line-height: 1.86;\r\n}\r\n\r\n.ai-family-hero-actions {\r\n    margin-top: 30px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 14px;\r\n}\r\n\r\n.ai-family-hero-button {\r\n    min-width: 172px;\r\n    padding: 15px 28px;\r\n    border-radius: 999px;\r\n    font-weight: 700;\r\n    transition:\r\n        transform 0.22s ease,\r\n        box-shadow 0.22s ease,\r\n        background 0.22s ease,\r\n        border-color 0.22s ease;\r\n}\r\n\r\n.ai-family-hero-button.is-primary {\r\n    background: var(--accent-red);\r\n    color: #ffffff;\r\n    box-shadow: 0 14px 30px rgba(217, 0, 27, 0.24);\r\n}\r\n\r\n.ai-family-hero-button.is-primary:hover {\r\n    background: var(--accent-red-hover);\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 18px 34px rgba(217, 0, 27, 0.28);\r\n}\r\n\r\n.ai-family-hero-button.is-secondary {\r\n    background: rgba(255, 255, 255, 0.06);\r\n    color: #ffffff;\r\n    border: 1px solid rgba(255, 255, 255, 0.16);\r\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n.ai-family-hero-button.is-secondary:hover {\n    background: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.24);\n    transform: translateY(-2px);\n}\n\n.ai-family-hero-button.is-disabled {\n    background: rgba(255, 255, 255, 0.08);\n    color: rgba(255, 255, 255, 0.78);\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\r\n@keyframes aiFamilyGridMove {\r\n    from {\r\n        transform: perspective(720px) rotateX(64deg) translateY(0);\r\n    }\r\n\r\n    to {\r\n        transform: perspective(720px) rotateX(64deg) translateY(44px);\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .ai-family-hero-content {\r\n        padding-top: 118px;\r\n        padding-bottom: 64px;\r\n        min-height: 100svh;\r\n    }\r\n\r\n    .ai-family-visual-shell {\r\n        width: min(68vw, 280px);\r\n        min-width: 0;\r\n        margin-bottom: 22px;\r\n    }\r\n\r\n    .ai-family-visual-ring {\r\n        inset: -12px;\r\n        border-radius: 24px;\r\n    }\r\n\r\n    .ai-family-visual-card {\r\n        border-radius: 22px;\r\n    }\r\n\r\n    .ai-family-hero-title {\r\n        margin-top: 18px;\r\n        max-width: 100%;\r\n        font-size: clamp(1.95rem, 8.2vw, 3rem);\r\n        line-height: 1.14;\r\n        white-space: normal;\r\n    }\r\n\r\n    .ai-family-hero-actions {\r\n        width: 100%;\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n        gap: 12px;\r\n    }\r\n\r\n    .ai-family-hero-button {\r\n        width: 100%;\r\n        min-width: 0;\r\n        padding: 14px 22px;\r\n    }\r\n\r\n    .ai-family-hero-subtitle {\r\n        max-width: 100%;\r\n        font-size: 0.98rem;\r\n        line-height: 1.78;\r\n    }\r\n\r\n    .ai-family-kicker {\r\n        font-size: 0.72rem;\r\n        letter-spacing: 0.14em;\r\n    }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n    .ai-family-grid,\r\n    .ai-family-hero-button {\r\n        animation: none;\r\n        transition: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
